import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectService} from "@catcore/services";
import {BreadcrumbService} from "@catmodules/widgets/breadcrumb/services/breadcrumb.service";
import {isNullOrUndefined} from "util";
import {Subscription} from "rxjs";
import {Project} from "@catcore/types/api-v2";

@Component({
  selector: 'catapp-project-ggw-fixed-route-list',
  templateUrl: './project-ggw-fixed-route-list.component.html',
  styleUrls: ['./project-ggw-fixed-route-list.component.scss']
})
export class ProjectGgwFixedRouteListComponent implements OnInit, OnDestroy {

  fixedRoutes = [];

  tableItems = [];
  dataTableInitialized: boolean;
  project: Project;

  projectSubscription: Subscription;
  fixedRoutesSubscription: Subscription;

  constructor(private projectService: ProjectService,
              private breadcrumbService: BreadcrumbService) { }

  ngOnInit() {
    // first get the current project
    this.projectSubscription = this.projectService.getCurrentProject()
      .subscribe((project) => {
        const isActiveProject = !isNullOrUndefined(project) && !isNullOrUndefined(project.id);
        if (isActiveProject) {
          this.dataTableInitialized = false;
          this.project = project;
          if (this.fixedRoutesSubscription) {
            this.fixedRoutesSubscription.unsubscribe();
          }

          this.fixedRoutesSubscription = this.projectService.getGgwFixedRoutes(this.project)
            .subscribe((fixedRoutes: any) => {
              this.fixedRoutes = fixedRoutes;
              this.updateDataTable();
            });
        }
      });

    this.breadcrumbService.update([{label: 'Fixed Routes', value: 'ggwFixedRoutes' }]);
  }

  ngOnDestroy() {
    this.projectSubscription.unsubscribe();
    if (this.fixedRoutesSubscription) {
      this.fixedRoutesSubscription.unsubscribe();
    }
  }

  dataAvailable() {
    return this.tableItems.length > 0;
  }

  private updateDataTable() {
    this.tableItems = [];
    this.fixedRoutes.forEach((fixedRoute) => {
      const item = {
        sourceName: fixedRoute._links.source.label,
        sourceZone: fixedRoute._embedded.source._links.gui_zone.label,
        sourceConfigName: fixedRoute._embedded.source.resolved_config_name,
        output: fixedRoute.output,
        sinkName: fixedRoute._links.sink.label,
        sinkZone: fixedRoute._embedded.sink._links.gui_zone.label,
        sinkConfigName: fixedRoute._embedded.sink.resolved_config_name,
        input: fixedRoute.input
      };
      this.tableItems = [
        ...this.tableItems,
        item
      ];
    });
    this.dataTableInitialized = true;
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/ggw-fixed-routes/components/project-ggw-fixed-route-list/project-ggw-fixed-route-list.component.ts